module.exports = __webpack_public_path__ + "img/delete_icon.992af395.png";